var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pa-5"},[_c('v-col',[_c('inputs-list',{attrs:{"enrollment":_vm.enrollment,"course":_vm.course}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }